import React, { useRef, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { FaImage, FaVideo, FaFile } from "react-icons/fa"
import { toast } from "react-toastify"
import { api } from "../../app/Api/ApiSlice"
import { useSelector } from "react-redux"

const EditOrgPost = () => {
    const navigate = useNavigate()
    const { state } = useLocation()

    const { post } = state

    const [postText, setPostText] = useState(post.postText || "")
    const [audience, setAudience] = useState(post.audience || "public")
    const [postLabel, setPostLabel] = useState(post.label || "")
    const [loading, setLoading] = useState(false)
   

    /* ---------------- FILE HANDLING ---------------- */
    const removeFile = async () => { }



    /* ---------------- SUBMIT ---------------- */

    const handleSubmit = async (e) => {
        e.preventDefault()

        try {
            setLoading(true)
            await api.patch(`/${post.organization.name}/posts/${post._id}`, {
                postText,
                postLabel,
                audience,
            })
            setLoading(false)

            toast.success("Post updated successfully")
            navigate(-1)

        } catch (err) {
            toast.error(err.message || "Update failed")
        } finally {
            setLoading(false)
        }
    }

    /* ---------------- UI ---------------- */

    return (
        <div className="">
            <div className="form-wrapper create-form">
                <h3>Edit Post</h3>

                <form onSubmit={handleSubmit}>
                    <textarea
                        type="text"
                        placeholder="Type something..."
                        value={postText}
                        onChange={(e) => setPostText(e.target.value)}
                        cols={60}
                        rows={10}
                    />


                    <div className="edit-orgpost-file-previews">
                        {post.files.map((file, i) => (
                            <div key={i} className="file-preview">
                                <img src={file.url} alt="" className="edit-orgpost-img"/>
                                <button type="button" onClick={() => removeFile(i)}>Remove</button>
                            </div>
                        ))}
                    </div>

                    <div className="form-select">
                        <label>Audience</label>
                        <select value={audience} onChange={(e) => setAudience(e.target.value)}>
                            <option value="members">Members</option>
                            <option value="friends">Friends</option>
                            <option value="public">Public</option>
                        </select>
                    </div>

                    <button type="submit" disabled={loading}>
                        {loading ? "Updating..." : "Update Post"}
                    </button>
                </form>
            </div>
        </div>
    )
}

export default EditOrgPost
